const HOTKEYS_ENABLED_TAGS = ['INPUT', 'SELECT', 'TEXTAREA']

export default HOTKEYS_ENABLED_TAGS
